/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createAccount = /* GraphQL */ `
  mutation CreateAccount(
    $condition: ModelaccountConditionInput
    $input: CreateAccountInput!
  ) {
    createAccount(condition: $condition, input: $input) {
      availability
      birthday
      campaign {
        items {
          business_list {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          clicks
          createdAt
          description
          end_age
          end_campaign
          end_hour
          extra_notification
          gender
          id
          id_marketer {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          interest
          offer_type
          repeat
          repeat_time
          scope
          shopping
          sort_attribute
          start_age
          start_campaign
          start_hour
          status
          subcategory
          title
          type
          updatedAt
          url_image
          zone_list
        }
        nextToken
      }
      categoryUser {
        items {
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          createdAt
          id
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      chatsUser {
        items {
          chat_id {
            active
            createdAt
            id
            new_message
            updatedAt
          }
          createdAt
          id
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      createdAt
      current_session
      customer_orders {
        items {
          address
          bill_id {
            createdAt
            description
            id
            status
            total
            updatedAt
          }
          canceled
          collects {
            nextToken
          }
          com_customer
          com_shop
          createdAt
          customer_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          delivery_man_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          discount
          discount_array {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          final_total
          history
          id
          level
          method_pay
          nc
          orderDetails
          order_case
          order_type
          payment_id
          percentage
          phase
          products {
            nextToken
          }
          propina
          require_bill
          require_service
          reviews {
            nextToken
          }
          shop_comments
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          shop_idToSort
          status
          total
          tracking_coordinates
          updatedAt
        }
        nextToken
      }
      deleted_at
      delivery_inprocess
      deliveryman_collects {
        items {
          come_date
          createdAt
          deliveryman_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          finished
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          origin_sign
          picking_date
          sign
          type
          updatedAt
        }
        nextToken
      }
      deliveryman_orders {
        items {
          address
          bill_id {
            createdAt
            description
            id
            status
            total
            updatedAt
          }
          canceled
          collects {
            nextToken
          }
          com_customer
          com_shop
          createdAt
          customer_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          delivery_man_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          discount
          discount_array {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          final_total
          history
          id
          level
          method_pay
          nc
          orderDetails
          order_case
          order_type
          payment_id
          percentage
          phase
          products {
            nextToken
          }
          propina
          require_bill
          require_service
          reviews {
            nextToken
          }
          shop_comments
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          shop_idToSort
          status
          total
          tracking_coordinates
          updatedAt
        }
        nextToken
      }
      email
      favorites {
        items {
          createdAt
          id
          product_id {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      favorites_shops
      id
      interests
      last_name
      messages {
        items {
          chat_id
          content
          createdAt
          expiration_time
          id
          image_url
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      name
      nikucoins
      notification_token
      openPay_id
      payments_vehicle {
        items {
          createdAt
          date
          deliveryman_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          id
          method_pay
          pay
          status
          updatedAt
        }
        nextToken
      }
      pending_chats
      phone_number
      rfc
      role
      sended_reviews {
        items {
          comment
          createdAt
          evaluator_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          id
          note
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          reviewEvaluated_idId
          updatedAt
        }
        nextToken
      }
      sexo
      shops {
        items {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        nextToken
      }
      updatedAt
      url_photoProfile
      user_addresses {
        items {
          active
          address_id {
            city
            country
            createdAt
            id
            interior_number
            latitude
            longitude
            outdoor_number
            postal_code
            street
            town
            updatedAt
          }
          createdAt
          id
          tag
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          zip_codes
        }
        nextToken
      }
      vehicles {
        items {
          active
          createdAt
          delivery_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          id
          mark
          model
          niv
          price
          status
          temporal
          type_vehicle
          updatedAt
          zone_id {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
        }
        nextToken
      }
      zip_codes
      zone
      zones {
        items {
          active
          bases {
            nextToken
          }
          createdAt
          deliverymen_inZone
          franchisse_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          id
          updatedAt
          vehicles {
            nextToken
          }
          zone_name
          zone_state
        }
        nextToken
      }
    }
  }
`;
export const createActiveCampaigns = /* GraphQL */ `
  mutation CreateActiveCampaigns(
    $condition: ModelactiveCampaignsConditionInput
    $input: CreateActiveCampaignsInput!
  ) {
    createActiveCampaigns(condition: $condition, input: $input) {
      TTLCampaign
      createdAt
      description
      end_age
      end_campaign
      gender
      id
      interest
      repeat
      repeat_time
      sort_attribute
      start_age
      start_campaign
      status
      title
      type
      updatedAt
      url_image
      zone_list
    }
  }
`;
export const createAddress = /* GraphQL */ `
  mutation CreateAddress(
    $condition: ModeladdressConditionInput
    $input: CreateAddressInput!
  ) {
    createAddress(condition: $condition, input: $input) {
      city
      country
      createdAt
      id
      interior_number
      latitude
      longitude
      outdoor_number
      postal_code
      street
      town
      updatedAt
      user_addresses {
        items {
          active
          address_id {
            city
            country
            createdAt
            id
            interior_number
            latitude
            longitude
            outdoor_number
            postal_code
            street
            town
            updatedAt
          }
          createdAt
          id
          tag
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          zip_codes
        }
        nextToken
      }
    }
  }
`;
export const createBase = /* GraphQL */ `
  mutation CreateBase(
    $condition: ModelbaseConditionInput
    $input: CreateBaseInput!
  ) {
    createBase(condition: $condition, input: $input) {
      active
      address
      country
      createdAt
      description
      id
      updatedAt
      zone_id {
        active
        bases {
          items {
            active
            address
            country
            createdAt
            description
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        deliverymen_inZone
        franchisse_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        id
        updatedAt
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zone_name
        zone_state
      }
    }
  }
`;
export const createBill = /* GraphQL */ `
  mutation CreateBill(
    $condition: ModelbillConditionInput
    $input: CreateBillInput!
  ) {
    createBill(condition: $condition, input: $input) {
      createdAt
      description
      id
      order_id {
        address
        bill_id {
          createdAt
          description
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          status
          total
          updatedAt
        }
        canceled
        collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        com_customer
        com_shop
        createdAt
        customer_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        delivery_man_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        discount
        discount_array {
          createdAt
          for_use
          id
          orders {
            nextToken
          }
          percentage_id {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          used
          value
        }
        final_total
        history
        id
        level
        method_pay
        nc
        orderDetails
        order_case
        order_type
        payment_id
        percentage
        phase
        products {
          items {
            additional_features
            comments
            createdAt
            id
            price
            quantity
            quote_state
            updatedAt
            url_audio
            url_image
          }
          nextToken
        }
        propina
        require_bill
        require_service
        reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        shop_comments
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        shop_idToSort
        status
        total
        tracking_coordinates
        updatedAt
      }
      status
      total
      updatedAt
    }
  }
`;
export const createCampaign = /* GraphQL */ `
  mutation CreateCampaign(
    $condition: ModelcampaignConditionInput
    $input: CreateCampaignInput!
  ) {
    createCampaign(condition: $condition, input: $input) {
      business_list {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      category_id {
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category_name
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        category_user {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        id
        subcategories
        tags
        updatedAt
      }
      clicks
      createdAt
      description
      end_age
      end_campaign
      end_hour
      extra_notification
      gender
      id
      id_marketer {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      interest
      offer_type
      repeat
      repeat_time
      scope
      shopping
      sort_attribute
      start_age
      start_campaign
      start_hour
      status
      subcategory
      title
      type
      updatedAt
      url_image
      zone_list
    }
  }
`;
export const createCategory = /* GraphQL */ `
  mutation CreateCategory(
    $condition: ModelcategoryConditionInput
    $input: CreateCategoryInput!
  ) {
    createCategory(condition: $condition, input: $input) {
      campaigns {
        items {
          business_list {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          clicks
          createdAt
          description
          end_age
          end_campaign
          end_hour
          extra_notification
          gender
          id
          id_marketer {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          interest
          offer_type
          repeat
          repeat_time
          scope
          shopping
          sort_attribute
          start_age
          start_campaign
          start_hour
          status
          subcategory
          title
          type
          updatedAt
          url_image
          zone_list
        }
        nextToken
      }
      category_name
      category_shop {
        items {
          aisles
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          createdAt
          id
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          subcategory
          updatedAt
        }
        nextToken
      }
      category_user {
        items {
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          createdAt
          id
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      createdAt
      id
      subcategories
      tags
      updatedAt
    }
  }
`;
export const createCategoryShop = /* GraphQL */ `
  mutation CreateCategoryShop(
    $condition: ModelcategoryShopConditionInput
    $input: CreateCategoryShopInput!
  ) {
    createCategoryShop(condition: $condition, input: $input) {
      aisles
      category_id {
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category_name
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        category_user {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        id
        subcategories
        tags
        updatedAt
      }
      createdAt
      id
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      subcategory
      updatedAt
    }
  }
`;
export const createCategoryUser = /* GraphQL */ `
  mutation CreateCategoryUser(
    $condition: ModelcategoryUserConditionInput
    $input: CreateCategoryUserInput!
  ) {
    createCategoryUser(condition: $condition, input: $input) {
      category_id {
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category_name
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        category_user {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        id
        subcategories
        tags
        updatedAt
      }
      createdAt
      id
      updatedAt
      user_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
    }
  }
`;
export const createChat = /* GraphQL */ `
  mutation CreateChat(
    $condition: ModelchatConditionInput
    $input: CreateChatInput!
  ) {
    createChat(condition: $condition, input: $input) {
      active
      chatsUser {
        items {
          chat_id {
            active
            createdAt
            id
            new_message
            updatedAt
          }
          createdAt
          id
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      createdAt
      id
      new_message
      updatedAt
    }
  }
`;
export const createChatUser = /* GraphQL */ `
  mutation CreateChatUser(
    $condition: ModelchatUserConditionInput
    $input: CreateChatUserInput!
  ) {
    createChatUser(condition: $condition, input: $input) {
      chat_id {
        active
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        id
        new_message
        updatedAt
      }
      createdAt
      id
      updatedAt
      user_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
    }
  }
`;
export const createCollect = /* GraphQL */ `
  mutation CreateCollect(
    $condition: ModelcollectConditionInput
    $input: CreateCollectInput!
  ) {
    createCollect(condition: $condition, input: $input) {
      come_date
      createdAt
      deliveryman_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      finished
      id
      order_id {
        address
        bill_id {
          createdAt
          description
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          status
          total
          updatedAt
        }
        canceled
        collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        com_customer
        com_shop
        createdAt
        customer_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        delivery_man_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        discount
        discount_array {
          createdAt
          for_use
          id
          orders {
            nextToken
          }
          percentage_id {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          used
          value
        }
        final_total
        history
        id
        level
        method_pay
        nc
        orderDetails
        order_case
        order_type
        payment_id
        percentage
        phase
        products {
          items {
            additional_features
            comments
            createdAt
            id
            price
            quantity
            quote_state
            updatedAt
            url_audio
            url_image
          }
          nextToken
        }
        propina
        require_bill
        require_service
        reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        shop_comments
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        shop_idToSort
        status
        total
        tracking_coordinates
        updatedAt
      }
      origin_sign
      picking_date
      sign
      type
      updatedAt
    }
  }
`;
export const createDiscount = /* GraphQL */ `
  mutation CreateDiscount(
    $condition: ModeldiscountConditionInput
    $input: CreateDiscountInput!
  ) {
    createDiscount(condition: $condition, input: $input) {
      createdAt
      for_use
      id
      orders {
        items {
          address
          bill_id {
            createdAt
            description
            id
            status
            total
            updatedAt
          }
          canceled
          collects {
            nextToken
          }
          com_customer
          com_shop
          createdAt
          customer_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          delivery_man_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          discount
          discount_array {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          final_total
          history
          id
          level
          method_pay
          nc
          orderDetails
          order_case
          order_type
          payment_id
          percentage
          phase
          products {
            nextToken
          }
          propina
          require_bill
          require_service
          reviews {
            nextToken
          }
          shop_comments
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          shop_idToSort
          status
          total
          tracking_coordinates
          updatedAt
        }
        nextToken
      }
      percentage_id {
        array_ofDiscount
        createdAt
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        id
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        value
      }
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      updatedAt
      used
      value
    }
  }
`;
export const createFavorite = /* GraphQL */ `
  mutation CreateFavorite(
    $condition: ModelfavoriteConditionInput
    $input: CreateFavoriteInput!
  ) {
    createFavorite(condition: $condition, input: $input) {
      createdAt
      id
      product_id {
        additional_features
        aisle
        createdAt
        description
        expiry_ticket
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        keywords
        limit_ticket
        mature
        netcontent
        offerprice
        orders {
          items {
            additional_features
            comments
            createdAt
            id
            price
            quantity
            quote_state
            updatedAt
            url_audio
            url_image
          }
          nextToken
        }
        own_deliveryMan
        price
        product_name
        product_type
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        status
        subtag
        tags
        updatedAt
        url_image
      }
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      updatedAt
      user_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
    }
  }
`;
export const createMessage = /* GraphQL */ `
  mutation CreateMessage(
    $condition: ModelmessageConditionInput
    $input: CreateMessageInput!
  ) {
    createMessage(condition: $condition, input: $input) {
      chat_id
      content
      createdAt
      expiration_time
      id
      image_url
      updatedAt
      user_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
    }
  }
`;
export const createOrder = /* GraphQL */ `
  mutation CreateOrder(
    $condition: ModelorderConditionInput
    $input: CreateOrderInput!
  ) {
    createOrder(condition: $condition, input: $input) {
      address
      bill_id {
        createdAt
        description
        id
        order_id {
          address
          bill_id {
            createdAt
            description
            id
            status
            total
            updatedAt
          }
          canceled
          collects {
            nextToken
          }
          com_customer
          com_shop
          createdAt
          customer_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          delivery_man_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          discount
          discount_array {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          final_total
          history
          id
          level
          method_pay
          nc
          orderDetails
          order_case
          order_type
          payment_id
          percentage
          phase
          products {
            nextToken
          }
          propina
          require_bill
          require_service
          reviews {
            nextToken
          }
          shop_comments
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          shop_idToSort
          status
          total
          tracking_coordinates
          updatedAt
        }
        status
        total
        updatedAt
      }
      canceled
      collects {
        items {
          come_date
          createdAt
          deliveryman_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          finished
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          origin_sign
          picking_date
          sign
          type
          updatedAt
        }
        nextToken
      }
      com_customer
      com_shop
      createdAt
      customer_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      delivery_man_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      discount
      discount_array {
        createdAt
        for_use
        id
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        percentage_id {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        updatedAt
        used
        value
      }
      final_total
      history
      id
      level
      method_pay
      nc
      orderDetails
      order_case
      order_type
      payment_id
      percentage
      phase
      products {
        items {
          additional_features
          comments
          createdAt
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          price
          product_id {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          quantity
          quote_state
          updatedAt
          url_audio
          url_image
        }
        nextToken
      }
      propina
      require_bill
      require_service
      reviews {
        items {
          comment
          createdAt
          evaluator_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          id
          note
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          reviewEvaluated_idId
          updatedAt
        }
        nextToken
      }
      shop_comments
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      shop_idToSort
      status
      total
      tracking_coordinates
      updatedAt
    }
  }
`;
export const createOrderProduct = /* GraphQL */ `
  mutation CreateOrderProduct(
    $condition: ModelorderProductConditionInput
    $input: CreateOrderProductInput!
  ) {
    createOrderProduct(condition: $condition, input: $input) {
      additional_features
      comments
      createdAt
      id
      order_id {
        address
        bill_id {
          createdAt
          description
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          status
          total
          updatedAt
        }
        canceled
        collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        com_customer
        com_shop
        createdAt
        customer_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        delivery_man_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        discount
        discount_array {
          createdAt
          for_use
          id
          orders {
            nextToken
          }
          percentage_id {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          used
          value
        }
        final_total
        history
        id
        level
        method_pay
        nc
        orderDetails
        order_case
        order_type
        payment_id
        percentage
        phase
        products {
          items {
            additional_features
            comments
            createdAt
            id
            price
            quantity
            quote_state
            updatedAt
            url_audio
            url_image
          }
          nextToken
        }
        propina
        require_bill
        require_service
        reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        shop_comments
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        shop_idToSort
        status
        total
        tracking_coordinates
        updatedAt
      }
      price
      product_id {
        additional_features
        aisle
        createdAt
        description
        expiry_ticket
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        keywords
        limit_ticket
        mature
        netcontent
        offerprice
        orders {
          items {
            additional_features
            comments
            createdAt
            id
            price
            quantity
            quote_state
            updatedAt
            url_audio
            url_image
          }
          nextToken
        }
        own_deliveryMan
        price
        product_name
        product_type
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        status
        subtag
        tags
        updatedAt
        url_image
      }
      quantity
      quote_state
      updatedAt
      url_audio
      url_image
    }
  }
`;
export const createPaymentHistory = /* GraphQL */ `
  mutation CreatePaymentHistory(
    $condition: ModelpaymentHistoryConditionInput
    $input: CreatePaymentHistoryInput!
  ) {
    createPaymentHistory(condition: $condition, input: $input) {
      createdAt
      frequency
      id
      period
      plan
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      status
      total_amount
      type
      updatedAt
    }
  }
`;
export const createPaymentVehicle = /* GraphQL */ `
  mutation CreatePaymentVehicle(
    $condition: ModelpaymentVehicleConditionInput
    $input: CreatePaymentVehicleInput!
  ) {
    createPaymentVehicle(condition: $condition, input: $input) {
      createdAt
      date
      deliveryman_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      id
      method_pay
      pay
      status
      updatedAt
    }
  }
`;
export const createPercentage = /* GraphQL */ `
  mutation CreatePercentage(
    $condition: ModelpercentageConditionInput
    $input: CreatePercentageInput!
  ) {
    createPercentage(condition: $condition, input: $input) {
      array_ofDiscount
      createdAt
      discounts {
        items {
          createdAt
          for_use
          id
          orders {
            nextToken
          }
          percentage_id {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          used
          value
        }
        nextToken
      }
      id
      shops {
        items {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        nextToken
      }
      updatedAt
      value
    }
  }
`;
export const createProduct = /* GraphQL */ `
  mutation CreateProduct(
    $condition: ModelproductConditionInput
    $input: CreateProductInput!
  ) {
    createProduct(condition: $condition, input: $input) {
      additional_features
      aisle
      createdAt
      description
      expiry_ticket
      favorites {
        items {
          createdAt
          id
          product_id {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      id
      keywords
      limit_ticket
      mature
      netcontent
      offerprice
      orders {
        items {
          additional_features
          comments
          createdAt
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          price
          product_id {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          quantity
          quote_state
          updatedAt
          url_audio
          url_image
        }
        nextToken
      }
      own_deliveryMan
      price
      product_name
      product_type
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      status
      subtag
      tags
      updatedAt
      url_image
    }
  }
`;
export const createPublicity = /* GraphQL */ `
  mutation CreatePublicity(
    $condition: ModelpublicityConditionInput
    $input: CreatePublicityInput!
  ) {
    createPublicity(condition: $condition, input: $input) {
      createdAt
      deleted_at
      id
      publicity_name
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      status
      updatedAt
      url_image
    }
  }
`;
export const createReview = /* GraphQL */ `
  mutation CreateReview(
    $condition: ModelreviewConditionInput
    $input: CreateReviewInput!
  ) {
    createReview(condition: $condition, input: $input) {
      comment
      createdAt
      evaluator_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      id
      note
      order_id {
        address
        bill_id {
          createdAt
          description
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          status
          total
          updatedAt
        }
        canceled
        collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        com_customer
        com_shop
        createdAt
        customer_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        delivery_man_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        discount
        discount_array {
          createdAt
          for_use
          id
          orders {
            nextToken
          }
          percentage_id {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          used
          value
        }
        final_total
        history
        id
        level
        method_pay
        nc
        orderDetails
        order_case
        order_type
        payment_id
        percentage
        phase
        products {
          items {
            additional_features
            comments
            createdAt
            id
            price
            quantity
            quote_state
            updatedAt
            url_audio
            url_image
          }
          nextToken
        }
        propina
        require_bill
        require_service
        reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        shop_comments
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        shop_idToSort
        status
        total
        tracking_coordinates
        updatedAt
      }
      reviewEvaluated_idId
      updatedAt
    }
  }
`;
export const createShop = /* GraphQL */ `
  mutation CreateShop(
    $condition: ModelshopConditionInput
    $input: CreateShopInput!
  ) {
    createShop(condition: $condition, input: $input) {
      acceptCard
      address_coords
      address_shop
      affiliator_id
      availability
      business_name
      campaigns {
        items {
          business_list {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          clicks
          createdAt
          description
          end_age
          end_campaign
          end_hour
          extra_notification
          gender
          id
          id_marketer {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          interest
          offer_type
          repeat
          repeat_time
          scope
          shopping
          sort_attribute
          start_age
          start_campaign
          start_hour
          status
          subcategory
          title
          type
          updatedAt
          url_image
          zone_list
        }
        nextToken
      }
      category
      categoryId
      category_shop {
        items {
          aisles
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          createdAt
          id
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          subcategory
          updatedAt
        }
        nextToken
      }
      city
      country
      createdAt
      created_by_affiliator
      deleted_at
      description
      discounts {
        items {
          createdAt
          for_use
          id
          orders {
            nextToken
          }
          percentage_id {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          used
          value
        }
        nextToken
      }
      discountsArray
      favorites {
        items {
          createdAt
          id
          product_id {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      id
      interclb
      method_pay
      orders {
        items {
          address
          bill_id {
            createdAt
            description
            id
            status
            total
            updatedAt
          }
          canceled
          collects {
            nextToken
          }
          com_customer
          com_shop
          createdAt
          customer_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          delivery_man_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          discount
          discount_array {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          final_total
          history
          id
          level
          method_pay
          nc
          orderDetails
          order_case
          order_type
          payment_id
          percentage
          phase
          products {
            nextToken
          }
          propina
          require_bill
          require_service
          reviews {
            nextToken
          }
          shop_comments
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          shop_idToSort
          status
          total
          tracking_coordinates
          updatedAt
        }
        nextToken
      }
      paymentsHistory {
        items {
          createdAt
          frequency
          id
          period
          plan
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          status
          total_amount
          type
          updatedAt
        }
        nextToken
      }
      percentage_traded {
        array_ofDiscount
        createdAt
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        id
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        value
      }
      phone_number
      postal_code
      price
      products {
        items {
          additional_features
          aisle
          createdAt
          description
          expiry_ticket
          favorites {
            nextToken
          }
          id
          keywords
          limit_ticket
          mature
          netcontent
          offerprice
          orders {
            nextToken
          }
          own_deliveryMan
          price
          product_name
          product_type
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          status
          subtag
          tags
          updatedAt
          url_image
        }
        nextToken
      }
      publicities {
        items {
          createdAt
          deleted_at
          id
          publicity_name
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          status
          updatedAt
          url_image
        }
        nextToken
      }
      rating
      schedule
      seller_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      shop_name
      shop_type
      showAddress
      status
      subcategory
      updatedAt
      url_documents
      url_image
      url_pdf
      zone
    }
  }
`;
export const createUserAddress = /* GraphQL */ `
  mutation CreateUserAddress(
    $condition: ModeluserAddressConditionInput
    $input: CreateUserAddressInput!
  ) {
    createUserAddress(condition: $condition, input: $input) {
      active
      address_id {
        city
        country
        createdAt
        id
        interior_number
        latitude
        longitude
        outdoor_number
        postal_code
        street
        town
        updatedAt
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
      }
      createdAt
      id
      tag
      updatedAt
      user_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      zip_codes
    }
  }
`;
export const createVehicle = /* GraphQL */ `
  mutation CreateVehicle(
    $condition: ModelvehicleConditionInput
    $input: CreateVehicleInput!
  ) {
    createVehicle(condition: $condition, input: $input) {
      active
      createdAt
      delivery_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      id
      mark
      model
      niv
      price
      status
      temporal
      type_vehicle
      updatedAt
      zone_id {
        active
        bases {
          items {
            active
            address
            country
            createdAt
            description
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        deliverymen_inZone
        franchisse_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        id
        updatedAt
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zone_name
        zone_state
      }
    }
  }
`;
export const createZone = /* GraphQL */ `
  mutation CreateZone(
    $condition: ModelzoneConditionInput
    $input: CreateZoneInput!
  ) {
    createZone(condition: $condition, input: $input) {
      active
      bases {
        items {
          active
          address
          country
          createdAt
          description
          id
          updatedAt
          zone_id {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
        }
        nextToken
      }
      createdAt
      deliverymen_inZone
      franchisse_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      id
      updatedAt
      vehicles {
        items {
          active
          createdAt
          delivery_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          id
          mark
          model
          niv
          price
          status
          temporal
          type_vehicle
          updatedAt
          zone_id {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
        }
        nextToken
      }
      zone_name
      zone_state
    }
  }
`;
export const deleteAccount = /* GraphQL */ `
  mutation DeleteAccount(
    $condition: ModelaccountConditionInput
    $input: DeleteAccountInput!
  ) {
    deleteAccount(condition: $condition, input: $input) {
      availability
      birthday
      campaign {
        items {
          business_list {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          clicks
          createdAt
          description
          end_age
          end_campaign
          end_hour
          extra_notification
          gender
          id
          id_marketer {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          interest
          offer_type
          repeat
          repeat_time
          scope
          shopping
          sort_attribute
          start_age
          start_campaign
          start_hour
          status
          subcategory
          title
          type
          updatedAt
          url_image
          zone_list
        }
        nextToken
      }
      categoryUser {
        items {
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          createdAt
          id
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      chatsUser {
        items {
          chat_id {
            active
            createdAt
            id
            new_message
            updatedAt
          }
          createdAt
          id
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      createdAt
      current_session
      customer_orders {
        items {
          address
          bill_id {
            createdAt
            description
            id
            status
            total
            updatedAt
          }
          canceled
          collects {
            nextToken
          }
          com_customer
          com_shop
          createdAt
          customer_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          delivery_man_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          discount
          discount_array {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          final_total
          history
          id
          level
          method_pay
          nc
          orderDetails
          order_case
          order_type
          payment_id
          percentage
          phase
          products {
            nextToken
          }
          propina
          require_bill
          require_service
          reviews {
            nextToken
          }
          shop_comments
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          shop_idToSort
          status
          total
          tracking_coordinates
          updatedAt
        }
        nextToken
      }
      deleted_at
      delivery_inprocess
      deliveryman_collects {
        items {
          come_date
          createdAt
          deliveryman_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          finished
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          origin_sign
          picking_date
          sign
          type
          updatedAt
        }
        nextToken
      }
      deliveryman_orders {
        items {
          address
          bill_id {
            createdAt
            description
            id
            status
            total
            updatedAt
          }
          canceled
          collects {
            nextToken
          }
          com_customer
          com_shop
          createdAt
          customer_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          delivery_man_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          discount
          discount_array {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          final_total
          history
          id
          level
          method_pay
          nc
          orderDetails
          order_case
          order_type
          payment_id
          percentage
          phase
          products {
            nextToken
          }
          propina
          require_bill
          require_service
          reviews {
            nextToken
          }
          shop_comments
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          shop_idToSort
          status
          total
          tracking_coordinates
          updatedAt
        }
        nextToken
      }
      email
      favorites {
        items {
          createdAt
          id
          product_id {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      favorites_shops
      id
      interests
      last_name
      messages {
        items {
          chat_id
          content
          createdAt
          expiration_time
          id
          image_url
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      name
      nikucoins
      notification_token
      openPay_id
      payments_vehicle {
        items {
          createdAt
          date
          deliveryman_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          id
          method_pay
          pay
          status
          updatedAt
        }
        nextToken
      }
      pending_chats
      phone_number
      rfc
      role
      sended_reviews {
        items {
          comment
          createdAt
          evaluator_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          id
          note
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          reviewEvaluated_idId
          updatedAt
        }
        nextToken
      }
      sexo
      shops {
        items {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        nextToken
      }
      updatedAt
      url_photoProfile
      user_addresses {
        items {
          active
          address_id {
            city
            country
            createdAt
            id
            interior_number
            latitude
            longitude
            outdoor_number
            postal_code
            street
            town
            updatedAt
          }
          createdAt
          id
          tag
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          zip_codes
        }
        nextToken
      }
      vehicles {
        items {
          active
          createdAt
          delivery_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          id
          mark
          model
          niv
          price
          status
          temporal
          type_vehicle
          updatedAt
          zone_id {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
        }
        nextToken
      }
      zip_codes
      zone
      zones {
        items {
          active
          bases {
            nextToken
          }
          createdAt
          deliverymen_inZone
          franchisse_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          id
          updatedAt
          vehicles {
            nextToken
          }
          zone_name
          zone_state
        }
        nextToken
      }
    }
  }
`;
export const deleteActiveCampaigns = /* GraphQL */ `
  mutation DeleteActiveCampaigns(
    $condition: ModelactiveCampaignsConditionInput
    $input: DeleteActiveCampaignsInput!
  ) {
    deleteActiveCampaigns(condition: $condition, input: $input) {
      TTLCampaign
      createdAt
      description
      end_age
      end_campaign
      gender
      id
      interest
      repeat
      repeat_time
      sort_attribute
      start_age
      start_campaign
      status
      title
      type
      updatedAt
      url_image
      zone_list
    }
  }
`;
export const deleteAddress = /* GraphQL */ `
  mutation DeleteAddress(
    $condition: ModeladdressConditionInput
    $input: DeleteAddressInput!
  ) {
    deleteAddress(condition: $condition, input: $input) {
      city
      country
      createdAt
      id
      interior_number
      latitude
      longitude
      outdoor_number
      postal_code
      street
      town
      updatedAt
      user_addresses {
        items {
          active
          address_id {
            city
            country
            createdAt
            id
            interior_number
            latitude
            longitude
            outdoor_number
            postal_code
            street
            town
            updatedAt
          }
          createdAt
          id
          tag
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          zip_codes
        }
        nextToken
      }
    }
  }
`;
export const deleteBase = /* GraphQL */ `
  mutation DeleteBase(
    $condition: ModelbaseConditionInput
    $input: DeleteBaseInput!
  ) {
    deleteBase(condition: $condition, input: $input) {
      active
      address
      country
      createdAt
      description
      id
      updatedAt
      zone_id {
        active
        bases {
          items {
            active
            address
            country
            createdAt
            description
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        deliverymen_inZone
        franchisse_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        id
        updatedAt
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zone_name
        zone_state
      }
    }
  }
`;
export const deleteBill = /* GraphQL */ `
  mutation DeleteBill(
    $condition: ModelbillConditionInput
    $input: DeleteBillInput!
  ) {
    deleteBill(condition: $condition, input: $input) {
      createdAt
      description
      id
      order_id {
        address
        bill_id {
          createdAt
          description
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          status
          total
          updatedAt
        }
        canceled
        collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        com_customer
        com_shop
        createdAt
        customer_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        delivery_man_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        discount
        discount_array {
          createdAt
          for_use
          id
          orders {
            nextToken
          }
          percentage_id {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          used
          value
        }
        final_total
        history
        id
        level
        method_pay
        nc
        orderDetails
        order_case
        order_type
        payment_id
        percentage
        phase
        products {
          items {
            additional_features
            comments
            createdAt
            id
            price
            quantity
            quote_state
            updatedAt
            url_audio
            url_image
          }
          nextToken
        }
        propina
        require_bill
        require_service
        reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        shop_comments
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        shop_idToSort
        status
        total
        tracking_coordinates
        updatedAt
      }
      status
      total
      updatedAt
    }
  }
`;
export const deleteCampaign = /* GraphQL */ `
  mutation DeleteCampaign(
    $condition: ModelcampaignConditionInput
    $input: DeleteCampaignInput!
  ) {
    deleteCampaign(condition: $condition, input: $input) {
      business_list {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      category_id {
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category_name
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        category_user {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        id
        subcategories
        tags
        updatedAt
      }
      clicks
      createdAt
      description
      end_age
      end_campaign
      end_hour
      extra_notification
      gender
      id
      id_marketer {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      interest
      offer_type
      repeat
      repeat_time
      scope
      shopping
      sort_attribute
      start_age
      start_campaign
      start_hour
      status
      subcategory
      title
      type
      updatedAt
      url_image
      zone_list
    }
  }
`;
export const deleteCategory = /* GraphQL */ `
  mutation DeleteCategory(
    $condition: ModelcategoryConditionInput
    $input: DeleteCategoryInput!
  ) {
    deleteCategory(condition: $condition, input: $input) {
      campaigns {
        items {
          business_list {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          clicks
          createdAt
          description
          end_age
          end_campaign
          end_hour
          extra_notification
          gender
          id
          id_marketer {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          interest
          offer_type
          repeat
          repeat_time
          scope
          shopping
          sort_attribute
          start_age
          start_campaign
          start_hour
          status
          subcategory
          title
          type
          updatedAt
          url_image
          zone_list
        }
        nextToken
      }
      category_name
      category_shop {
        items {
          aisles
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          createdAt
          id
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          subcategory
          updatedAt
        }
        nextToken
      }
      category_user {
        items {
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          createdAt
          id
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      createdAt
      id
      subcategories
      tags
      updatedAt
    }
  }
`;
export const deleteCategoryShop = /* GraphQL */ `
  mutation DeleteCategoryShop(
    $condition: ModelcategoryShopConditionInput
    $input: DeleteCategoryShopInput!
  ) {
    deleteCategoryShop(condition: $condition, input: $input) {
      aisles
      category_id {
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category_name
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        category_user {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        id
        subcategories
        tags
        updatedAt
      }
      createdAt
      id
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      subcategory
      updatedAt
    }
  }
`;
export const deleteCategoryUser = /* GraphQL */ `
  mutation DeleteCategoryUser(
    $condition: ModelcategoryUserConditionInput
    $input: DeleteCategoryUserInput!
  ) {
    deleteCategoryUser(condition: $condition, input: $input) {
      category_id {
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category_name
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        category_user {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        id
        subcategories
        tags
        updatedAt
      }
      createdAt
      id
      updatedAt
      user_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
    }
  }
`;
export const deleteChat = /* GraphQL */ `
  mutation DeleteChat(
    $condition: ModelchatConditionInput
    $input: DeleteChatInput!
  ) {
    deleteChat(condition: $condition, input: $input) {
      active
      chatsUser {
        items {
          chat_id {
            active
            createdAt
            id
            new_message
            updatedAt
          }
          createdAt
          id
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      createdAt
      id
      new_message
      updatedAt
    }
  }
`;
export const deleteChatUser = /* GraphQL */ `
  mutation DeleteChatUser(
    $condition: ModelchatUserConditionInput
    $input: DeleteChatUserInput!
  ) {
    deleteChatUser(condition: $condition, input: $input) {
      chat_id {
        active
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        id
        new_message
        updatedAt
      }
      createdAt
      id
      updatedAt
      user_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
    }
  }
`;
export const deleteCollect = /* GraphQL */ `
  mutation DeleteCollect(
    $condition: ModelcollectConditionInput
    $input: DeleteCollectInput!
  ) {
    deleteCollect(condition: $condition, input: $input) {
      come_date
      createdAt
      deliveryman_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      finished
      id
      order_id {
        address
        bill_id {
          createdAt
          description
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          status
          total
          updatedAt
        }
        canceled
        collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        com_customer
        com_shop
        createdAt
        customer_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        delivery_man_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        discount
        discount_array {
          createdAt
          for_use
          id
          orders {
            nextToken
          }
          percentage_id {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          used
          value
        }
        final_total
        history
        id
        level
        method_pay
        nc
        orderDetails
        order_case
        order_type
        payment_id
        percentage
        phase
        products {
          items {
            additional_features
            comments
            createdAt
            id
            price
            quantity
            quote_state
            updatedAt
            url_audio
            url_image
          }
          nextToken
        }
        propina
        require_bill
        require_service
        reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        shop_comments
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        shop_idToSort
        status
        total
        tracking_coordinates
        updatedAt
      }
      origin_sign
      picking_date
      sign
      type
      updatedAt
    }
  }
`;
export const deleteDiscount = /* GraphQL */ `
  mutation DeleteDiscount(
    $condition: ModeldiscountConditionInput
    $input: DeleteDiscountInput!
  ) {
    deleteDiscount(condition: $condition, input: $input) {
      createdAt
      for_use
      id
      orders {
        items {
          address
          bill_id {
            createdAt
            description
            id
            status
            total
            updatedAt
          }
          canceled
          collects {
            nextToken
          }
          com_customer
          com_shop
          createdAt
          customer_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          delivery_man_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          discount
          discount_array {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          final_total
          history
          id
          level
          method_pay
          nc
          orderDetails
          order_case
          order_type
          payment_id
          percentage
          phase
          products {
            nextToken
          }
          propina
          require_bill
          require_service
          reviews {
            nextToken
          }
          shop_comments
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          shop_idToSort
          status
          total
          tracking_coordinates
          updatedAt
        }
        nextToken
      }
      percentage_id {
        array_ofDiscount
        createdAt
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        id
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        value
      }
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      updatedAt
      used
      value
    }
  }
`;
export const deleteFavorite = /* GraphQL */ `
  mutation DeleteFavorite(
    $condition: ModelfavoriteConditionInput
    $input: DeleteFavoriteInput!
  ) {
    deleteFavorite(condition: $condition, input: $input) {
      createdAt
      id
      product_id {
        additional_features
        aisle
        createdAt
        description
        expiry_ticket
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        keywords
        limit_ticket
        mature
        netcontent
        offerprice
        orders {
          items {
            additional_features
            comments
            createdAt
            id
            price
            quantity
            quote_state
            updatedAt
            url_audio
            url_image
          }
          nextToken
        }
        own_deliveryMan
        price
        product_name
        product_type
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        status
        subtag
        tags
        updatedAt
        url_image
      }
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      updatedAt
      user_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
    }
  }
`;
export const deleteMessage = /* GraphQL */ `
  mutation DeleteMessage(
    $condition: ModelmessageConditionInput
    $input: DeleteMessageInput!
  ) {
    deleteMessage(condition: $condition, input: $input) {
      chat_id
      content
      createdAt
      expiration_time
      id
      image_url
      updatedAt
      user_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
    }
  }
`;
export const deleteOrder = /* GraphQL */ `
  mutation DeleteOrder(
    $condition: ModelorderConditionInput
    $input: DeleteOrderInput!
  ) {
    deleteOrder(condition: $condition, input: $input) {
      address
      bill_id {
        createdAt
        description
        id
        order_id {
          address
          bill_id {
            createdAt
            description
            id
            status
            total
            updatedAt
          }
          canceled
          collects {
            nextToken
          }
          com_customer
          com_shop
          createdAt
          customer_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          delivery_man_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          discount
          discount_array {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          final_total
          history
          id
          level
          method_pay
          nc
          orderDetails
          order_case
          order_type
          payment_id
          percentage
          phase
          products {
            nextToken
          }
          propina
          require_bill
          require_service
          reviews {
            nextToken
          }
          shop_comments
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          shop_idToSort
          status
          total
          tracking_coordinates
          updatedAt
        }
        status
        total
        updatedAt
      }
      canceled
      collects {
        items {
          come_date
          createdAt
          deliveryman_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          finished
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          origin_sign
          picking_date
          sign
          type
          updatedAt
        }
        nextToken
      }
      com_customer
      com_shop
      createdAt
      customer_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      delivery_man_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      discount
      discount_array {
        createdAt
        for_use
        id
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        percentage_id {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        updatedAt
        used
        value
      }
      final_total
      history
      id
      level
      method_pay
      nc
      orderDetails
      order_case
      order_type
      payment_id
      percentage
      phase
      products {
        items {
          additional_features
          comments
          createdAt
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          price
          product_id {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          quantity
          quote_state
          updatedAt
          url_audio
          url_image
        }
        nextToken
      }
      propina
      require_bill
      require_service
      reviews {
        items {
          comment
          createdAt
          evaluator_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          id
          note
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          reviewEvaluated_idId
          updatedAt
        }
        nextToken
      }
      shop_comments
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      shop_idToSort
      status
      total
      tracking_coordinates
      updatedAt
    }
  }
`;
export const deleteOrderProduct = /* GraphQL */ `
  mutation DeleteOrderProduct(
    $condition: ModelorderProductConditionInput
    $input: DeleteOrderProductInput!
  ) {
    deleteOrderProduct(condition: $condition, input: $input) {
      additional_features
      comments
      createdAt
      id
      order_id {
        address
        bill_id {
          createdAt
          description
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          status
          total
          updatedAt
        }
        canceled
        collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        com_customer
        com_shop
        createdAt
        customer_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        delivery_man_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        discount
        discount_array {
          createdAt
          for_use
          id
          orders {
            nextToken
          }
          percentage_id {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          used
          value
        }
        final_total
        history
        id
        level
        method_pay
        nc
        orderDetails
        order_case
        order_type
        payment_id
        percentage
        phase
        products {
          items {
            additional_features
            comments
            createdAt
            id
            price
            quantity
            quote_state
            updatedAt
            url_audio
            url_image
          }
          nextToken
        }
        propina
        require_bill
        require_service
        reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        shop_comments
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        shop_idToSort
        status
        total
        tracking_coordinates
        updatedAt
      }
      price
      product_id {
        additional_features
        aisle
        createdAt
        description
        expiry_ticket
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        keywords
        limit_ticket
        mature
        netcontent
        offerprice
        orders {
          items {
            additional_features
            comments
            createdAt
            id
            price
            quantity
            quote_state
            updatedAt
            url_audio
            url_image
          }
          nextToken
        }
        own_deliveryMan
        price
        product_name
        product_type
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        status
        subtag
        tags
        updatedAt
        url_image
      }
      quantity
      quote_state
      updatedAt
      url_audio
      url_image
    }
  }
`;
export const deletePaymentHistory = /* GraphQL */ `
  mutation DeletePaymentHistory(
    $condition: ModelpaymentHistoryConditionInput
    $input: DeletePaymentHistoryInput!
  ) {
    deletePaymentHistory(condition: $condition, input: $input) {
      createdAt
      frequency
      id
      period
      plan
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      status
      total_amount
      type
      updatedAt
    }
  }
`;
export const deletePaymentVehicle = /* GraphQL */ `
  mutation DeletePaymentVehicle(
    $condition: ModelpaymentVehicleConditionInput
    $input: DeletePaymentVehicleInput!
  ) {
    deletePaymentVehicle(condition: $condition, input: $input) {
      createdAt
      date
      deliveryman_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      id
      method_pay
      pay
      status
      updatedAt
    }
  }
`;
export const deletePercentage = /* GraphQL */ `
  mutation DeletePercentage(
    $condition: ModelpercentageConditionInput
    $input: DeletePercentageInput!
  ) {
    deletePercentage(condition: $condition, input: $input) {
      array_ofDiscount
      createdAt
      discounts {
        items {
          createdAt
          for_use
          id
          orders {
            nextToken
          }
          percentage_id {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          used
          value
        }
        nextToken
      }
      id
      shops {
        items {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        nextToken
      }
      updatedAt
      value
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct(
    $condition: ModelproductConditionInput
    $input: DeleteProductInput!
  ) {
    deleteProduct(condition: $condition, input: $input) {
      additional_features
      aisle
      createdAt
      description
      expiry_ticket
      favorites {
        items {
          createdAt
          id
          product_id {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      id
      keywords
      limit_ticket
      mature
      netcontent
      offerprice
      orders {
        items {
          additional_features
          comments
          createdAt
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          price
          product_id {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          quantity
          quote_state
          updatedAt
          url_audio
          url_image
        }
        nextToken
      }
      own_deliveryMan
      price
      product_name
      product_type
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      status
      subtag
      tags
      updatedAt
      url_image
    }
  }
`;
export const deletePublicity = /* GraphQL */ `
  mutation DeletePublicity(
    $condition: ModelpublicityConditionInput
    $input: DeletePublicityInput!
  ) {
    deletePublicity(condition: $condition, input: $input) {
      createdAt
      deleted_at
      id
      publicity_name
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      status
      updatedAt
      url_image
    }
  }
`;
export const deleteReview = /* GraphQL */ `
  mutation DeleteReview(
    $condition: ModelreviewConditionInput
    $input: DeleteReviewInput!
  ) {
    deleteReview(condition: $condition, input: $input) {
      comment
      createdAt
      evaluator_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      id
      note
      order_id {
        address
        bill_id {
          createdAt
          description
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          status
          total
          updatedAt
        }
        canceled
        collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        com_customer
        com_shop
        createdAt
        customer_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        delivery_man_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        discount
        discount_array {
          createdAt
          for_use
          id
          orders {
            nextToken
          }
          percentage_id {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          used
          value
        }
        final_total
        history
        id
        level
        method_pay
        nc
        orderDetails
        order_case
        order_type
        payment_id
        percentage
        phase
        products {
          items {
            additional_features
            comments
            createdAt
            id
            price
            quantity
            quote_state
            updatedAt
            url_audio
            url_image
          }
          nextToken
        }
        propina
        require_bill
        require_service
        reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        shop_comments
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        shop_idToSort
        status
        total
        tracking_coordinates
        updatedAt
      }
      reviewEvaluated_idId
      updatedAt
    }
  }
`;
export const deleteShop = /* GraphQL */ `
  mutation DeleteShop(
    $condition: ModelshopConditionInput
    $input: DeleteShopInput!
  ) {
    deleteShop(condition: $condition, input: $input) {
      acceptCard
      address_coords
      address_shop
      affiliator_id
      availability
      business_name
      campaigns {
        items {
          business_list {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          clicks
          createdAt
          description
          end_age
          end_campaign
          end_hour
          extra_notification
          gender
          id
          id_marketer {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          interest
          offer_type
          repeat
          repeat_time
          scope
          shopping
          sort_attribute
          start_age
          start_campaign
          start_hour
          status
          subcategory
          title
          type
          updatedAt
          url_image
          zone_list
        }
        nextToken
      }
      category
      categoryId
      category_shop {
        items {
          aisles
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          createdAt
          id
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          subcategory
          updatedAt
        }
        nextToken
      }
      city
      country
      createdAt
      created_by_affiliator
      deleted_at
      description
      discounts {
        items {
          createdAt
          for_use
          id
          orders {
            nextToken
          }
          percentage_id {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          used
          value
        }
        nextToken
      }
      discountsArray
      favorites {
        items {
          createdAt
          id
          product_id {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      id
      interclb
      method_pay
      orders {
        items {
          address
          bill_id {
            createdAt
            description
            id
            status
            total
            updatedAt
          }
          canceled
          collects {
            nextToken
          }
          com_customer
          com_shop
          createdAt
          customer_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          delivery_man_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          discount
          discount_array {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          final_total
          history
          id
          level
          method_pay
          nc
          orderDetails
          order_case
          order_type
          payment_id
          percentage
          phase
          products {
            nextToken
          }
          propina
          require_bill
          require_service
          reviews {
            nextToken
          }
          shop_comments
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          shop_idToSort
          status
          total
          tracking_coordinates
          updatedAt
        }
        nextToken
      }
      paymentsHistory {
        items {
          createdAt
          frequency
          id
          period
          plan
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          status
          total_amount
          type
          updatedAt
        }
        nextToken
      }
      percentage_traded {
        array_ofDiscount
        createdAt
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        id
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        value
      }
      phone_number
      postal_code
      price
      products {
        items {
          additional_features
          aisle
          createdAt
          description
          expiry_ticket
          favorites {
            nextToken
          }
          id
          keywords
          limit_ticket
          mature
          netcontent
          offerprice
          orders {
            nextToken
          }
          own_deliveryMan
          price
          product_name
          product_type
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          status
          subtag
          tags
          updatedAt
          url_image
        }
        nextToken
      }
      publicities {
        items {
          createdAt
          deleted_at
          id
          publicity_name
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          status
          updatedAt
          url_image
        }
        nextToken
      }
      rating
      schedule
      seller_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      shop_name
      shop_type
      showAddress
      status
      subcategory
      updatedAt
      url_documents
      url_image
      url_pdf
      zone
    }
  }
`;
export const deleteUserAddress = /* GraphQL */ `
  mutation DeleteUserAddress(
    $condition: ModeluserAddressConditionInput
    $input: DeleteUserAddressInput!
  ) {
    deleteUserAddress(condition: $condition, input: $input) {
      active
      address_id {
        city
        country
        createdAt
        id
        interior_number
        latitude
        longitude
        outdoor_number
        postal_code
        street
        town
        updatedAt
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
      }
      createdAt
      id
      tag
      updatedAt
      user_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      zip_codes
    }
  }
`;
export const deleteVehicle = /* GraphQL */ `
  mutation DeleteVehicle(
    $condition: ModelvehicleConditionInput
    $input: DeleteVehicleInput!
  ) {
    deleteVehicle(condition: $condition, input: $input) {
      active
      createdAt
      delivery_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      id
      mark
      model
      niv
      price
      status
      temporal
      type_vehicle
      updatedAt
      zone_id {
        active
        bases {
          items {
            active
            address
            country
            createdAt
            description
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        deliverymen_inZone
        franchisse_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        id
        updatedAt
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zone_name
        zone_state
      }
    }
  }
`;
export const deleteZone = /* GraphQL */ `
  mutation DeleteZone(
    $condition: ModelzoneConditionInput
    $input: DeleteZoneInput!
  ) {
    deleteZone(condition: $condition, input: $input) {
      active
      bases {
        items {
          active
          address
          country
          createdAt
          description
          id
          updatedAt
          zone_id {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
        }
        nextToken
      }
      createdAt
      deliverymen_inZone
      franchisse_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      id
      updatedAt
      vehicles {
        items {
          active
          createdAt
          delivery_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          id
          mark
          model
          niv
          price
          status
          temporal
          type_vehicle
          updatedAt
          zone_id {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
        }
        nextToken
      }
      zone_name
      zone_state
    }
  }
`;
export const example = /* GraphQL */ `
  mutation Example($input: ProductInput) {
    example(input: $input) {
      additional_features
      aisle
      createdAt
      description
      expiry_ticket
      favorites {
        items {
          createdAt
          id
          product_id {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      id
      keywords
      limit_ticket
      mature
      netcontent
      offerprice
      orders {
        items {
          additional_features
          comments
          createdAt
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          price
          product_id {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          quantity
          quote_state
          updatedAt
          url_audio
          url_image
        }
        nextToken
      }
      own_deliveryMan
      price
      product_name
      product_type
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      status
      subtag
      tags
      updatedAt
      url_image
    }
  }
`;
export const updateAccount = /* GraphQL */ `
  mutation UpdateAccount(
    $condition: ModelaccountConditionInput
    $input: UpdateAccountInput!
  ) {
    updateAccount(condition: $condition, input: $input) {
      availability
      birthday
      campaign {
        items {
          business_list {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          clicks
          createdAt
          description
          end_age
          end_campaign
          end_hour
          extra_notification
          gender
          id
          id_marketer {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          interest
          offer_type
          repeat
          repeat_time
          scope
          shopping
          sort_attribute
          start_age
          start_campaign
          start_hour
          status
          subcategory
          title
          type
          updatedAt
          url_image
          zone_list
        }
        nextToken
      }
      categoryUser {
        items {
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          createdAt
          id
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      chatsUser {
        items {
          chat_id {
            active
            createdAt
            id
            new_message
            updatedAt
          }
          createdAt
          id
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      createdAt
      current_session
      customer_orders {
        items {
          address
          bill_id {
            createdAt
            description
            id
            status
            total
            updatedAt
          }
          canceled
          collects {
            nextToken
          }
          com_customer
          com_shop
          createdAt
          customer_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          delivery_man_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          discount
          discount_array {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          final_total
          history
          id
          level
          method_pay
          nc
          orderDetails
          order_case
          order_type
          payment_id
          percentage
          phase
          products {
            nextToken
          }
          propina
          require_bill
          require_service
          reviews {
            nextToken
          }
          shop_comments
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          shop_idToSort
          status
          total
          tracking_coordinates
          updatedAt
        }
        nextToken
      }
      deleted_at
      delivery_inprocess
      deliveryman_collects {
        items {
          come_date
          createdAt
          deliveryman_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          finished
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          origin_sign
          picking_date
          sign
          type
          updatedAt
        }
        nextToken
      }
      deliveryman_orders {
        items {
          address
          bill_id {
            createdAt
            description
            id
            status
            total
            updatedAt
          }
          canceled
          collects {
            nextToken
          }
          com_customer
          com_shop
          createdAt
          customer_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          delivery_man_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          discount
          discount_array {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          final_total
          history
          id
          level
          method_pay
          nc
          orderDetails
          order_case
          order_type
          payment_id
          percentage
          phase
          products {
            nextToken
          }
          propina
          require_bill
          require_service
          reviews {
            nextToken
          }
          shop_comments
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          shop_idToSort
          status
          total
          tracking_coordinates
          updatedAt
        }
        nextToken
      }
      email
      favorites {
        items {
          createdAt
          id
          product_id {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      favorites_shops
      id
      interests
      last_name
      messages {
        items {
          chat_id
          content
          createdAt
          expiration_time
          id
          image_url
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      name
      nikucoins
      notification_token
      openPay_id
      payments_vehicle {
        items {
          createdAt
          date
          deliveryman_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          id
          method_pay
          pay
          status
          updatedAt
        }
        nextToken
      }
      pending_chats
      phone_number
      rfc
      role
      sended_reviews {
        items {
          comment
          createdAt
          evaluator_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          id
          note
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          reviewEvaluated_idId
          updatedAt
        }
        nextToken
      }
      sexo
      shops {
        items {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        nextToken
      }
      updatedAt
      url_photoProfile
      user_addresses {
        items {
          active
          address_id {
            city
            country
            createdAt
            id
            interior_number
            latitude
            longitude
            outdoor_number
            postal_code
            street
            town
            updatedAt
          }
          createdAt
          id
          tag
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          zip_codes
        }
        nextToken
      }
      vehicles {
        items {
          active
          createdAt
          delivery_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          id
          mark
          model
          niv
          price
          status
          temporal
          type_vehicle
          updatedAt
          zone_id {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
        }
        nextToken
      }
      zip_codes
      zone
      zones {
        items {
          active
          bases {
            nextToken
          }
          createdAt
          deliverymen_inZone
          franchisse_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          id
          updatedAt
          vehicles {
            nextToken
          }
          zone_name
          zone_state
        }
        nextToken
      }
    }
  }
`;
export const updateActiveCampaigns = /* GraphQL */ `
  mutation UpdateActiveCampaigns(
    $condition: ModelactiveCampaignsConditionInput
    $input: UpdateActiveCampaignsInput!
  ) {
    updateActiveCampaigns(condition: $condition, input: $input) {
      TTLCampaign
      createdAt
      description
      end_age
      end_campaign
      gender
      id
      interest
      repeat
      repeat_time
      sort_attribute
      start_age
      start_campaign
      status
      title
      type
      updatedAt
      url_image
      zone_list
    }
  }
`;
export const updateAddress = /* GraphQL */ `
  mutation UpdateAddress(
    $condition: ModeladdressConditionInput
    $input: UpdateAddressInput!
  ) {
    updateAddress(condition: $condition, input: $input) {
      city
      country
      createdAt
      id
      interior_number
      latitude
      longitude
      outdoor_number
      postal_code
      street
      town
      updatedAt
      user_addresses {
        items {
          active
          address_id {
            city
            country
            createdAt
            id
            interior_number
            latitude
            longitude
            outdoor_number
            postal_code
            street
            town
            updatedAt
          }
          createdAt
          id
          tag
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          zip_codes
        }
        nextToken
      }
    }
  }
`;
export const updateBase = /* GraphQL */ `
  mutation UpdateBase(
    $condition: ModelbaseConditionInput
    $input: UpdateBaseInput!
  ) {
    updateBase(condition: $condition, input: $input) {
      active
      address
      country
      createdAt
      description
      id
      updatedAt
      zone_id {
        active
        bases {
          items {
            active
            address
            country
            createdAt
            description
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        deliverymen_inZone
        franchisse_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        id
        updatedAt
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zone_name
        zone_state
      }
    }
  }
`;
export const updateBill = /* GraphQL */ `
  mutation UpdateBill(
    $condition: ModelbillConditionInput
    $input: UpdateBillInput!
  ) {
    updateBill(condition: $condition, input: $input) {
      createdAt
      description
      id
      order_id {
        address
        bill_id {
          createdAt
          description
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          status
          total
          updatedAt
        }
        canceled
        collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        com_customer
        com_shop
        createdAt
        customer_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        delivery_man_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        discount
        discount_array {
          createdAt
          for_use
          id
          orders {
            nextToken
          }
          percentage_id {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          used
          value
        }
        final_total
        history
        id
        level
        method_pay
        nc
        orderDetails
        order_case
        order_type
        payment_id
        percentage
        phase
        products {
          items {
            additional_features
            comments
            createdAt
            id
            price
            quantity
            quote_state
            updatedAt
            url_audio
            url_image
          }
          nextToken
        }
        propina
        require_bill
        require_service
        reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        shop_comments
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        shop_idToSort
        status
        total
        tracking_coordinates
        updatedAt
      }
      status
      total
      updatedAt
    }
  }
`;
export const updateCampaign = /* GraphQL */ `
  mutation UpdateCampaign(
    $condition: ModelcampaignConditionInput
    $input: UpdateCampaignInput!
  ) {
    updateCampaign(condition: $condition, input: $input) {
      business_list {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      category_id {
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category_name
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        category_user {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        id
        subcategories
        tags
        updatedAt
      }
      clicks
      createdAt
      description
      end_age
      end_campaign
      end_hour
      extra_notification
      gender
      id
      id_marketer {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      interest
      offer_type
      repeat
      repeat_time
      scope
      shopping
      sort_attribute
      start_age
      start_campaign
      start_hour
      status
      subcategory
      title
      type
      updatedAt
      url_image
      zone_list
    }
  }
`;
export const updateCategory = /* GraphQL */ `
  mutation UpdateCategory(
    $condition: ModelcategoryConditionInput
    $input: UpdateCategoryInput!
  ) {
    updateCategory(condition: $condition, input: $input) {
      campaigns {
        items {
          business_list {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          clicks
          createdAt
          description
          end_age
          end_campaign
          end_hour
          extra_notification
          gender
          id
          id_marketer {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          interest
          offer_type
          repeat
          repeat_time
          scope
          shopping
          sort_attribute
          start_age
          start_campaign
          start_hour
          status
          subcategory
          title
          type
          updatedAt
          url_image
          zone_list
        }
        nextToken
      }
      category_name
      category_shop {
        items {
          aisles
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          createdAt
          id
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          subcategory
          updatedAt
        }
        nextToken
      }
      category_user {
        items {
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          createdAt
          id
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      createdAt
      id
      subcategories
      tags
      updatedAt
    }
  }
`;
export const updateCategoryShop = /* GraphQL */ `
  mutation UpdateCategoryShop(
    $condition: ModelcategoryShopConditionInput
    $input: UpdateCategoryShopInput!
  ) {
    updateCategoryShop(condition: $condition, input: $input) {
      aisles
      category_id {
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category_name
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        category_user {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        id
        subcategories
        tags
        updatedAt
      }
      createdAt
      id
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      subcategory
      updatedAt
    }
  }
`;
export const updateCategoryUser = /* GraphQL */ `
  mutation UpdateCategoryUser(
    $condition: ModelcategoryUserConditionInput
    $input: UpdateCategoryUserInput!
  ) {
    updateCategoryUser(condition: $condition, input: $input) {
      category_id {
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category_name
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        category_user {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        id
        subcategories
        tags
        updatedAt
      }
      createdAt
      id
      updatedAt
      user_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
    }
  }
`;
export const updateChat = /* GraphQL */ `
  mutation UpdateChat(
    $condition: ModelchatConditionInput
    $input: UpdateChatInput!
  ) {
    updateChat(condition: $condition, input: $input) {
      active
      chatsUser {
        items {
          chat_id {
            active
            createdAt
            id
            new_message
            updatedAt
          }
          createdAt
          id
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      createdAt
      id
      new_message
      updatedAt
    }
  }
`;
export const updateChatUser = /* GraphQL */ `
  mutation UpdateChatUser(
    $condition: ModelchatUserConditionInput
    $input: UpdateChatUserInput!
  ) {
    updateChatUser(condition: $condition, input: $input) {
      chat_id {
        active
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        id
        new_message
        updatedAt
      }
      createdAt
      id
      updatedAt
      user_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
    }
  }
`;
export const updateCollect = /* GraphQL */ `
  mutation UpdateCollect(
    $condition: ModelcollectConditionInput
    $input: UpdateCollectInput!
  ) {
    updateCollect(condition: $condition, input: $input) {
      come_date
      createdAt
      deliveryman_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      finished
      id
      order_id {
        address
        bill_id {
          createdAt
          description
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          status
          total
          updatedAt
        }
        canceled
        collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        com_customer
        com_shop
        createdAt
        customer_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        delivery_man_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        discount
        discount_array {
          createdAt
          for_use
          id
          orders {
            nextToken
          }
          percentage_id {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          used
          value
        }
        final_total
        history
        id
        level
        method_pay
        nc
        orderDetails
        order_case
        order_type
        payment_id
        percentage
        phase
        products {
          items {
            additional_features
            comments
            createdAt
            id
            price
            quantity
            quote_state
            updatedAt
            url_audio
            url_image
          }
          nextToken
        }
        propina
        require_bill
        require_service
        reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        shop_comments
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        shop_idToSort
        status
        total
        tracking_coordinates
        updatedAt
      }
      origin_sign
      picking_date
      sign
      type
      updatedAt
    }
  }
`;
export const updateDiscount = /* GraphQL */ `
  mutation UpdateDiscount(
    $condition: ModeldiscountConditionInput
    $input: UpdateDiscountInput!
  ) {
    updateDiscount(condition: $condition, input: $input) {
      createdAt
      for_use
      id
      orders {
        items {
          address
          bill_id {
            createdAt
            description
            id
            status
            total
            updatedAt
          }
          canceled
          collects {
            nextToken
          }
          com_customer
          com_shop
          createdAt
          customer_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          delivery_man_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          discount
          discount_array {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          final_total
          history
          id
          level
          method_pay
          nc
          orderDetails
          order_case
          order_type
          payment_id
          percentage
          phase
          products {
            nextToken
          }
          propina
          require_bill
          require_service
          reviews {
            nextToken
          }
          shop_comments
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          shop_idToSort
          status
          total
          tracking_coordinates
          updatedAt
        }
        nextToken
      }
      percentage_id {
        array_ofDiscount
        createdAt
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        id
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        value
      }
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      updatedAt
      used
      value
    }
  }
`;
export const updateFavorite = /* GraphQL */ `
  mutation UpdateFavorite(
    $condition: ModelfavoriteConditionInput
    $input: UpdateFavoriteInput!
  ) {
    updateFavorite(condition: $condition, input: $input) {
      createdAt
      id
      product_id {
        additional_features
        aisle
        createdAt
        description
        expiry_ticket
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        keywords
        limit_ticket
        mature
        netcontent
        offerprice
        orders {
          items {
            additional_features
            comments
            createdAt
            id
            price
            quantity
            quote_state
            updatedAt
            url_audio
            url_image
          }
          nextToken
        }
        own_deliveryMan
        price
        product_name
        product_type
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        status
        subtag
        tags
        updatedAt
        url_image
      }
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      updatedAt
      user_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
    }
  }
`;
export const updateMessage = /* GraphQL */ `
  mutation UpdateMessage(
    $condition: ModelmessageConditionInput
    $input: UpdateMessageInput!
  ) {
    updateMessage(condition: $condition, input: $input) {
      chat_id
      content
      createdAt
      expiration_time
      id
      image_url
      updatedAt
      user_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
    }
  }
`;
export const updateOrder = /* GraphQL */ `
  mutation UpdateOrder(
    $condition: ModelorderConditionInput
    $input: UpdateOrderInput!
  ) {
    updateOrder(condition: $condition, input: $input) {
      address
      bill_id {
        createdAt
        description
        id
        order_id {
          address
          bill_id {
            createdAt
            description
            id
            status
            total
            updatedAt
          }
          canceled
          collects {
            nextToken
          }
          com_customer
          com_shop
          createdAt
          customer_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          delivery_man_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          discount
          discount_array {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          final_total
          history
          id
          level
          method_pay
          nc
          orderDetails
          order_case
          order_type
          payment_id
          percentage
          phase
          products {
            nextToken
          }
          propina
          require_bill
          require_service
          reviews {
            nextToken
          }
          shop_comments
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          shop_idToSort
          status
          total
          tracking_coordinates
          updatedAt
        }
        status
        total
        updatedAt
      }
      canceled
      collects {
        items {
          come_date
          createdAt
          deliveryman_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          finished
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          origin_sign
          picking_date
          sign
          type
          updatedAt
        }
        nextToken
      }
      com_customer
      com_shop
      createdAt
      customer_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      delivery_man_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      discount
      discount_array {
        createdAt
        for_use
        id
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        percentage_id {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        updatedAt
        used
        value
      }
      final_total
      history
      id
      level
      method_pay
      nc
      orderDetails
      order_case
      order_type
      payment_id
      percentage
      phase
      products {
        items {
          additional_features
          comments
          createdAt
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          price
          product_id {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          quantity
          quote_state
          updatedAt
          url_audio
          url_image
        }
        nextToken
      }
      propina
      require_bill
      require_service
      reviews {
        items {
          comment
          createdAt
          evaluator_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          id
          note
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          reviewEvaluated_idId
          updatedAt
        }
        nextToken
      }
      shop_comments
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      shop_idToSort
      status
      total
      tracking_coordinates
      updatedAt
    }
  }
`;
export const updateOrderProduct = /* GraphQL */ `
  mutation UpdateOrderProduct(
    $condition: ModelorderProductConditionInput
    $input: UpdateOrderProductInput!
  ) {
    updateOrderProduct(condition: $condition, input: $input) {
      additional_features
      comments
      createdAt
      id
      order_id {
        address
        bill_id {
          createdAt
          description
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          status
          total
          updatedAt
        }
        canceled
        collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        com_customer
        com_shop
        createdAt
        customer_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        delivery_man_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        discount
        discount_array {
          createdAt
          for_use
          id
          orders {
            nextToken
          }
          percentage_id {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          used
          value
        }
        final_total
        history
        id
        level
        method_pay
        nc
        orderDetails
        order_case
        order_type
        payment_id
        percentage
        phase
        products {
          items {
            additional_features
            comments
            createdAt
            id
            price
            quantity
            quote_state
            updatedAt
            url_audio
            url_image
          }
          nextToken
        }
        propina
        require_bill
        require_service
        reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        shop_comments
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        shop_idToSort
        status
        total
        tracking_coordinates
        updatedAt
      }
      price
      product_id {
        additional_features
        aisle
        createdAt
        description
        expiry_ticket
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        keywords
        limit_ticket
        mature
        netcontent
        offerprice
        orders {
          items {
            additional_features
            comments
            createdAt
            id
            price
            quantity
            quote_state
            updatedAt
            url_audio
            url_image
          }
          nextToken
        }
        own_deliveryMan
        price
        product_name
        product_type
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        status
        subtag
        tags
        updatedAt
        url_image
      }
      quantity
      quote_state
      updatedAt
      url_audio
      url_image
    }
  }
`;
export const updatePaymentHistory = /* GraphQL */ `
  mutation UpdatePaymentHistory(
    $condition: ModelpaymentHistoryConditionInput
    $input: UpdatePaymentHistoryInput!
  ) {
    updatePaymentHistory(condition: $condition, input: $input) {
      createdAt
      frequency
      id
      period
      plan
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      status
      total_amount
      type
      updatedAt
    }
  }
`;
export const updatePaymentVehicle = /* GraphQL */ `
  mutation UpdatePaymentVehicle(
    $condition: ModelpaymentVehicleConditionInput
    $input: UpdatePaymentVehicleInput!
  ) {
    updatePaymentVehicle(condition: $condition, input: $input) {
      createdAt
      date
      deliveryman_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      id
      method_pay
      pay
      status
      updatedAt
    }
  }
`;
export const updatePercentage = /* GraphQL */ `
  mutation UpdatePercentage(
    $condition: ModelpercentageConditionInput
    $input: UpdatePercentageInput!
  ) {
    updatePercentage(condition: $condition, input: $input) {
      array_ofDiscount
      createdAt
      discounts {
        items {
          createdAt
          for_use
          id
          orders {
            nextToken
          }
          percentage_id {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          used
          value
        }
        nextToken
      }
      id
      shops {
        items {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        nextToken
      }
      updatedAt
      value
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct(
    $condition: ModelproductConditionInput
    $input: UpdateProductInput!
  ) {
    updateProduct(condition: $condition, input: $input) {
      additional_features
      aisle
      createdAt
      description
      expiry_ticket
      favorites {
        items {
          createdAt
          id
          product_id {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      id
      keywords
      limit_ticket
      mature
      netcontent
      offerprice
      orders {
        items {
          additional_features
          comments
          createdAt
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          price
          product_id {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          quantity
          quote_state
          updatedAt
          url_audio
          url_image
        }
        nextToken
      }
      own_deliveryMan
      price
      product_name
      product_type
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      status
      subtag
      tags
      updatedAt
      url_image
    }
  }
`;
export const updatePublicity = /* GraphQL */ `
  mutation UpdatePublicity(
    $condition: ModelpublicityConditionInput
    $input: UpdatePublicityInput!
  ) {
    updatePublicity(condition: $condition, input: $input) {
      createdAt
      deleted_at
      id
      publicity_name
      shop_id {
        acceptCard
        address_coords
        address_shop
        affiliator_id
        availability
        business_name
        campaigns {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        category
        categoryId
        category_shop {
          items {
            aisles
            createdAt
            id
            subcategory
            updatedAt
          }
          nextToken
        }
        city
        country
        createdAt
        created_by_affiliator
        deleted_at
        description
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        discountsArray
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        id
        interclb
        method_pay
        orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        paymentsHistory {
          items {
            createdAt
            frequency
            id
            period
            plan
            status
            total_amount
            type
            updatedAt
          }
          nextToken
        }
        percentage_traded {
          array_ofDiscount
          createdAt
          discounts {
            nextToken
          }
          id
          shops {
            nextToken
          }
          updatedAt
          value
        }
        phone_number
        postal_code
        price
        products {
          items {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          nextToken
        }
        publicities {
          items {
            createdAt
            deleted_at
            id
            publicity_name
            status
            updatedAt
            url_image
          }
          nextToken
        }
        rating
        schedule
        seller_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        shop_name
        shop_type
        showAddress
        status
        subcategory
        updatedAt
        url_documents
        url_image
        url_pdf
        zone
      }
      status
      updatedAt
      url_image
    }
  }
`;
export const updateReview = /* GraphQL */ `
  mutation UpdateReview(
    $condition: ModelreviewConditionInput
    $input: UpdateReviewInput!
  ) {
    updateReview(condition: $condition, input: $input) {
      comment
      createdAt
      evaluator_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      id
      note
      order_id {
        address
        bill_id {
          createdAt
          description
          id
          order_id {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          status
          total
          updatedAt
        }
        canceled
        collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        com_customer
        com_shop
        createdAt
        customer_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        delivery_man_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        discount
        discount_array {
          createdAt
          for_use
          id
          orders {
            nextToken
          }
          percentage_id {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          used
          value
        }
        final_total
        history
        id
        level
        method_pay
        nc
        orderDetails
        order_case
        order_type
        payment_id
        percentage
        phase
        products {
          items {
            additional_features
            comments
            createdAt
            id
            price
            quantity
            quote_state
            updatedAt
            url_audio
            url_image
          }
          nextToken
        }
        propina
        require_bill
        require_service
        reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        shop_comments
        shop_id {
          acceptCard
          address_coords
          address_shop
          affiliator_id
          availability
          business_name
          campaigns {
            nextToken
          }
          category
          categoryId
          category_shop {
            nextToken
          }
          city
          country
          createdAt
          created_by_affiliator
          deleted_at
          description
          discounts {
            nextToken
          }
          discountsArray
          favorites {
            nextToken
          }
          id
          interclb
          method_pay
          orders {
            nextToken
          }
          paymentsHistory {
            nextToken
          }
          percentage_traded {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          phone_number
          postal_code
          price
          products {
            nextToken
          }
          publicities {
            nextToken
          }
          rating
          schedule
          seller_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          shop_name
          shop_type
          showAddress
          status
          subcategory
          updatedAt
          url_documents
          url_image
          url_pdf
          zone
        }
        shop_idToSort
        status
        total
        tracking_coordinates
        updatedAt
      }
      reviewEvaluated_idId
      updatedAt
    }
  }
`;
export const updateShop = /* GraphQL */ `
  mutation UpdateShop(
    $condition: ModelshopConditionInput
    $input: UpdateShopInput!
  ) {
    updateShop(condition: $condition, input: $input) {
      acceptCard
      address_coords
      address_shop
      affiliator_id
      availability
      business_name
      campaigns {
        items {
          business_list {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          clicks
          createdAt
          description
          end_age
          end_campaign
          end_hour
          extra_notification
          gender
          id
          id_marketer {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          interest
          offer_type
          repeat
          repeat_time
          scope
          shopping
          sort_attribute
          start_age
          start_campaign
          start_hour
          status
          subcategory
          title
          type
          updatedAt
          url_image
          zone_list
        }
        nextToken
      }
      category
      categoryId
      category_shop {
        items {
          aisles
          category_id {
            category_name
            createdAt
            id
            subcategories
            tags
            updatedAt
          }
          createdAt
          id
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          subcategory
          updatedAt
        }
        nextToken
      }
      city
      country
      createdAt
      created_by_affiliator
      deleted_at
      description
      discounts {
        items {
          createdAt
          for_use
          id
          orders {
            nextToken
          }
          percentage_id {
            array_ofDiscount
            createdAt
            id
            updatedAt
            value
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          used
          value
        }
        nextToken
      }
      discountsArray
      favorites {
        items {
          createdAt
          id
          product_id {
            additional_features
            aisle
            createdAt
            description
            expiry_ticket
            id
            keywords
            limit_ticket
            mature
            netcontent
            offerprice
            own_deliveryMan
            price
            product_name
            product_type
            status
            subtag
            tags
            updatedAt
            url_image
          }
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          updatedAt
          user_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
        }
        nextToken
      }
      id
      interclb
      method_pay
      orders {
        items {
          address
          bill_id {
            createdAt
            description
            id
            status
            total
            updatedAt
          }
          canceled
          collects {
            nextToken
          }
          com_customer
          com_shop
          createdAt
          customer_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          delivery_man_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          discount
          discount_array {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          final_total
          history
          id
          level
          method_pay
          nc
          orderDetails
          order_case
          order_type
          payment_id
          percentage
          phase
          products {
            nextToken
          }
          propina
          require_bill
          require_service
          reviews {
            nextToken
          }
          shop_comments
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          shop_idToSort
          status
          total
          tracking_coordinates
          updatedAt
        }
        nextToken
      }
      paymentsHistory {
        items {
          createdAt
          frequency
          id
          period
          plan
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          status
          total_amount
          type
          updatedAt
        }
        nextToken
      }
      percentage_traded {
        array_ofDiscount
        createdAt
        discounts {
          items {
            createdAt
            for_use
            id
            updatedAt
            used
            value
          }
          nextToken
        }
        id
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        value
      }
      phone_number
      postal_code
      price
      products {
        items {
          additional_features
          aisle
          createdAt
          description
          expiry_ticket
          favorites {
            nextToken
          }
          id
          keywords
          limit_ticket
          mature
          netcontent
          offerprice
          orders {
            nextToken
          }
          own_deliveryMan
          price
          product_name
          product_type
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          status
          subtag
          tags
          updatedAt
          url_image
        }
        nextToken
      }
      publicities {
        items {
          createdAt
          deleted_at
          id
          publicity_name
          shop_id {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          status
          updatedAt
          url_image
        }
        nextToken
      }
      rating
      schedule
      seller_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      shop_name
      shop_type
      showAddress
      status
      subcategory
      updatedAt
      url_documents
      url_image
      url_pdf
      zone
    }
  }
`;
export const updateUserAddress = /* GraphQL */ `
  mutation UpdateUserAddress(
    $condition: ModeluserAddressConditionInput
    $input: UpdateUserAddressInput!
  ) {
    updateUserAddress(condition: $condition, input: $input) {
      active
      address_id {
        city
        country
        createdAt
        id
        interior_number
        latitude
        longitude
        outdoor_number
        postal_code
        street
        town
        updatedAt
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
      }
      createdAt
      id
      tag
      updatedAt
      user_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      zip_codes
    }
  }
`;
export const updateVehicle = /* GraphQL */ `
  mutation UpdateVehicle(
    $condition: ModelvehicleConditionInput
    $input: UpdateVehicleInput!
  ) {
    updateVehicle(condition: $condition, input: $input) {
      active
      createdAt
      delivery_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      id
      mark
      model
      niv
      price
      status
      temporal
      type_vehicle
      updatedAt
      zone_id {
        active
        bases {
          items {
            active
            address
            country
            createdAt
            description
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        deliverymen_inZone
        franchisse_id {
          availability
          birthday
          campaign {
            nextToken
          }
          categoryUser {
            nextToken
          }
          chatsUser {
            nextToken
          }
          createdAt
          current_session
          customer_orders {
            nextToken
          }
          deleted_at
          delivery_inprocess
          deliveryman_collects {
            nextToken
          }
          deliveryman_orders {
            nextToken
          }
          email
          favorites {
            nextToken
          }
          favorites_shops
          id
          interests
          last_name
          messages {
            nextToken
          }
          name
          nikucoins
          notification_token
          openPay_id
          payments_vehicle {
            nextToken
          }
          pending_chats
          phone_number
          rfc
          role
          sended_reviews {
            nextToken
          }
          sexo
          shops {
            nextToken
          }
          updatedAt
          url_photoProfile
          user_addresses {
            nextToken
          }
          vehicles {
            nextToken
          }
          zip_codes
          zone
          zones {
            nextToken
          }
        }
        id
        updatedAt
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zone_name
        zone_state
      }
    }
  }
`;
export const updateZone = /* GraphQL */ `
  mutation UpdateZone(
    $condition: ModelzoneConditionInput
    $input: UpdateZoneInput!
  ) {
    updateZone(condition: $condition, input: $input) {
      active
      bases {
        items {
          active
          address
          country
          createdAt
          description
          id
          updatedAt
          zone_id {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
        }
        nextToken
      }
      createdAt
      deliverymen_inZone
      franchisse_id {
        availability
        birthday
        campaign {
          items {
            clicks
            createdAt
            description
            end_age
            end_campaign
            end_hour
            extra_notification
            gender
            id
            interest
            offer_type
            repeat
            repeat_time
            scope
            shopping
            sort_attribute
            start_age
            start_campaign
            start_hour
            status
            subcategory
            title
            type
            updatedAt
            url_image
            zone_list
          }
          nextToken
        }
        categoryUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        chatsUser {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        createdAt
        current_session
        customer_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        deleted_at
        delivery_inprocess
        deliveryman_collects {
          items {
            come_date
            createdAt
            finished
            id
            origin_sign
            picking_date
            sign
            type
            updatedAt
          }
          nextToken
        }
        deliveryman_orders {
          items {
            address
            canceled
            com_customer
            com_shop
            createdAt
            discount
            final_total
            history
            id
            level
            method_pay
            nc
            orderDetails
            order_case
            order_type
            payment_id
            percentage
            phase
            propina
            require_bill
            require_service
            shop_comments
            shop_idToSort
            status
            total
            tracking_coordinates
            updatedAt
          }
          nextToken
        }
        email
        favorites {
          items {
            createdAt
            id
            updatedAt
          }
          nextToken
        }
        favorites_shops
        id
        interests
        last_name
        messages {
          items {
            chat_id
            content
            createdAt
            expiration_time
            id
            image_url
            updatedAt
          }
          nextToken
        }
        name
        nikucoins
        notification_token
        openPay_id
        payments_vehicle {
          items {
            createdAt
            date
            id
            method_pay
            pay
            status
            updatedAt
          }
          nextToken
        }
        pending_chats
        phone_number
        rfc
        role
        sended_reviews {
          items {
            comment
            createdAt
            id
            note
            reviewEvaluated_idId
            updatedAt
          }
          nextToken
        }
        sexo
        shops {
          items {
            acceptCard
            address_coords
            address_shop
            affiliator_id
            availability
            business_name
            category
            categoryId
            city
            country
            createdAt
            created_by_affiliator
            deleted_at
            description
            discountsArray
            id
            interclb
            method_pay
            phone_number
            postal_code
            price
            rating
            schedule
            shop_name
            shop_type
            showAddress
            status
            subcategory
            updatedAt
            url_documents
            url_image
            url_pdf
            zone
          }
          nextToken
        }
        updatedAt
        url_photoProfile
        user_addresses {
          items {
            active
            createdAt
            id
            tag
            updatedAt
            zip_codes
          }
          nextToken
        }
        vehicles {
          items {
            active
            createdAt
            id
            mark
            model
            niv
            price
            status
            temporal
            type_vehicle
            updatedAt
          }
          nextToken
        }
        zip_codes
        zone
        zones {
          items {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
          nextToken
        }
      }
      id
      updatedAt
      vehicles {
        items {
          active
          createdAt
          delivery_id {
            availability
            birthday
            createdAt
            current_session
            deleted_at
            delivery_inprocess
            email
            favorites_shops
            id
            interests
            last_name
            name
            nikucoins
            notification_token
            openPay_id
            pending_chats
            phone_number
            rfc
            role
            sexo
            updatedAt
            url_photoProfile
            zip_codes
            zone
          }
          id
          mark
          model
          niv
          price
          status
          temporal
          type_vehicle
          updatedAt
          zone_id {
            active
            createdAt
            deliverymen_inZone
            id
            updatedAt
            zone_name
            zone_state
          }
        }
        nextToken
      }
      zone_name
      zone_state
    }
  }
`;